import { IStorageType, MFRM_UNIFY_SESSION_INFO_KEY, IStorage, IUnifySessionInfo } from '../../conventions'

export const unifySessionInfo: IStorage<IUnifySessionInfo> = {
  key: MFRM_UNIFY_SESSION_INFO_KEY,
  storageType: IStorageType.Session,
  value: {}
}

export const CUSTOM_EVENT_SESSION_EXPIRATION = 'session-expiration'
